import { render } from "./Main.vue?vue&type=template&id=c985ef04"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"

import "./Main.vue?vue&type=style&index=0&id=c985ef04&scope=true&lang=css"
script.render = render

export default script